import {get} from './http';

export type PinterestProfileStatus = {
  username: string;
  display_name: string | null;
  avatar_url: string | null;
  profile_url: string;
  bio: string | null;
  follower_count: number | null;
  following_count: number | null;
  pin_count: number | null;
  board_count: number | null;
  created_at: string | null;
  website_url: string | null;
  is_private_profile: boolean | null;
  is_verified_merchant: boolean | null;
  // Pinterest's own numeric user id - best-effort (Pinterest's page-embedded Redux state, not a
  // documented API), null when that block is missing or unparsable. This is what a profile
  // collected through Investigations keys its actor identity on (see the pinterest_profile spider's
  // AUTHOR_ID field), so PinterestSubmissionPage must use it too rather than the username, or the
  // same creator submitted from each entry point produces two different submission identities.
  user_id: string | null;
};

export type PinterestPinOwner = {
  // Pinterest's numeric user id - the same identity as PinterestProfileStatus.user_id.
  user_id: string;
  username: string;
  display_name: string | null;
  avatar_url: string | null;
  profile_url: string;
  bio: string | null;
  follower_count: number | null;
  pin_count: number | null;
};

export type PinterestPinStatus = {
  pin_id: string;
  url: string;
  description: string | null;
  image_url: string | null;
  link: string | null;
  domain: string | null;
  is_video: boolean;
  save_count: number | null;
  board_name: string | null;
  board_url: string | null;
  owner: PinterestPinOwner;
};

export type PinterestLatestPin = {
  pin_id: string;
  url: string;
  description: string | null;
  thumbnail_url: string | null;
  is_video: boolean;
};

export const pinterestApi = {
  // Newest-first. Empty for a private, empty or unknown profile.
  latestPins: async (username: string, max = 12) =>
    get<{results: PinterestLatestPin[]}>(
      `/pinterest/profiles/${encodeURIComponent(username)}/pins`,
      {max}
    ),

  pinStatus: async (pinId: string) =>
    get<PinterestPinStatus>(`/pinterest/pins/${encodeURIComponent(pinId)}`),

  profileStatus: async (username: string, locale: string) =>
    get<PinterestProfileStatus>(`/pinterest/profiles/${encodeURIComponent(username)}`, {locale})
};
